import React, {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import styles from './styles.module.scss';
import {useSavedQueriesContext} from "../context/SavedQueriesContext";

const PopupDeleteSaved = ({id}: {id: string}) => {
  const {formatMessage} = useIntl();
  const {deleteSavedItem} = useSavedQueriesContext();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const header = [
    formatMessage({id: 'ai-reports-are-you-sure', defaultMessage: 'Are you sure you want to delete saved query?'}),
  ].filter(Boolean).join(' - ')

  return (
    <>
      <Button
        className={"btn btn-icon btn-light btn-sm custom-action-button"}
        onClick={() => handleShowModal()}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Cross.svg')}
          alt="i" width={30}
        />
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">{header}</h3>
          <div className={styles.buttonsContainer}>
            <Button
              className="btn btn-secondary btn-sm col-3 mx-3"
              onClick={() => handleCloseModal()}
            >
              {formatMessage({id: 'button-cancel', defaultMessage: 'Cancel'})}
            </Button>
            <Button
              className="btn-sm col-3 mx-3 custom-send-button"
              onClick={async () => {
                await deleteSavedItem(id);
                handleCloseModal();
              }}
              disabled={!id}
            >
              {formatMessage({id: 'ai-reports-are-you-sure-delete', defaultMessage: 'Delete'})}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupDeleteSaved;
